module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NR-b3116b9b145419578979df0eedf988ab.png";